module.exports = __webpack_public_path__ + "img/footer-icon-1.35164cf8.png";